// extracted by mini-css-extract-plugin
module.exports = {"follow":"styles_follow__2HGIG","follow-list":"styles_follow-list__o5t6D","search":"styles_search__UlM0M"};